export const NOT_STARTED = "NOT_STARTED";
export const IN_PROGRESS = "IN_PROGRESS";
export const DONE = "DONE";
export const DONE_WITH_ERROR = "DONE_WITH_ERROR";
